/**
 * Customer service form
 */
app.modal.support = (function() {
    "use strict";
    var formData = {},
        self = {

        init: function() {
            // only for skava enabled regions
            if (!app.main.getSettings().skavaEnabled) {
                app.page.loadPage('');
                return;
            }

            app.modal.init();
            // app.page.load('json/'+ app.main.getCurrentCulture() +'/page-support.json', self);
            // app.page.load('json/en-us/page-support.json', self);
            $.getJSON('json/en-us/page-support.json', self.render);

            // load supporting vendor script
            $.getScript('js/vendor/scripts/ua-parser.min.js', function() {
                if (UAParser) {
                    formData.browser = UAParser().browser.name +' '+ UAParser().browser.version;
                    formData.operating_system = UAParser().os.name +' '+ UAParser().os.version;
                }
            });
        },

        render: function(data) {
            app.main.getTemplate('modal-support', {}, true, function() {
                app.modal.load('modal-support', data);
                self.postRender();
            });
        },

        setSessionVals: function(data) {
            formData.cart_id = '';
            formData.session_id = 'No SID';

            var cart = app.skava.getCartData();
            // other data if it exists
            if (cart) {
                formData.cart_id = cart.cartId;
                formData.cart_user_id = cart.userId;

                if (cart.userName) {
                    formData.cart_user_name = cart.userName;
                }
            }
            
            if (app.skava.getSessionObj().sid) {
                formData.session_id = app.skava.getSessionObj().sid;
            }
        },

        postRender: function() {
            if (!app.skava.getSessionObj().sid) {
                // attempt to get session so post will be accepted
                app.skava.setUpSession(function() {
                    self.setSessionVals();

                }, function(err) {
                    // error, continue anyway
                    self.setSessionVals();
                });

            } else {
                self.setSessionVals();
            }

            // autofill url field
            formData.url = window.location.href;

            if (formData.url.indexOf('#support') > -1) {
                formData.url = app.page.getHistory(-1);
            }

            $('#field-support-url').val(formData.url);

            $('.required').on('blur', function(e) {
                var name = e.currentTarget.id.split('-')[2];

                if (!$(this).val()) {
                    $(this).addClass('error');
                    $('.field-error.'+ name).text(app.main.lang('error_required_field')).show();

                } else {
                    $(this).removeClass('error');
                    $('.field-error.'+ name).empty().hide();
                }
            });

            // gather known info
            formData.member_id = app.main.getProfile().member_id;
            formData.member_rank = app.main.getProfile().member_rank;
            formData.cookies_enabled = navigator.cookieEnabled;
            formData.referrer = document.referrer ? document.referrer : 'No referrer';
            formData.screen_resolution = window.screen.width +'x'+ window.screen.height;
            formData.browser_size = window.innerWidth +'x'+ window.innerHeight;
            // set as false in case messageHandler times out
            formData.third_party_cookies_enabled = false;

            // use logged-in user data if present
            var cookie = app.cookie.get('c_yl_skava'),
                cookieData;

            if (cookie) {
                cookieData = JSON.parse(cookie);

                if (cookieData) {
                    if (cookieData.member_id && parseInt(cookieData.member_id, 10) != formData.member_id) {
                        formData.submitter_id = parseInt(cookieData.member_id, 10);
                    }
                }
            }
        },

        // for remote 3rd party cookie testing
        // iframe is in templates/page-support.html
        messageHandler: function(e) {
            if (e.data === 'MM:3PCunsupported') {
                console.log('third party cookies are not supported');
                formData.third_party_cookies_enabled = false;

            } else if (e.data === 'MM:3PCsupported') {
                console.log('third party cookies are supported');
                formData.third_party_cookies_enabled = true;
            }
        },

        validateForm: function() {
            var isValid = true,
                currentField = $('#field-support-email');

            $('.required').each(function() {
                var name = $(this).attr('id').split('-')[2];

                if (!$(this).val()) {
                    $(this).addClass('error');
                    $('.field-error.'+ name).text(app.main.lang('error_required_field')).show();
                    isValid = false;

                } else {
                    $(this).removeClass('error');
                    $('.field-error.'+ name).empty().hide();
                }
            });

            if (app.pws.validateEmail(currentField.val())) {
                $('.field-error.email').empty().hide();
                currentField.removeClass('error');

            } else {
                $('.field-error.email').text(app.main.lang('error_email_invalid')).show();
                currentField.addClass('error');
                isValid = false;
            }

            currentField = $('#field-support-url');

            if (app.pws.validateURL(currentField.val())) {
                $('.field-error.url').empty().hide();
                currentField.removeClass('error');

            } else {
                $('.field-error.url').text(app.main.lang('error_invalid_url')).show();
                currentField.addClass('error');
                isValid = false;
            }

            return isValid;
        },
 
        submitForm: function(token) {
            console.log('submitForm');
            // add response token to formData
            formData.recaptcha_token = token;

            if (self.validateForm()) {
                var date = new Date();
                formData.date = date.toISOString();

                formData.first_name = $('#field-support-firstname').val();
                formData.last_name = $('#field-support-lastname').val();
                formData.email = $('#field-support-email').val();
                formData.url = $('#field-support-url').val();
                formData.history = app.page.getHistory();
                formData.description = "";

                if (formData.submitter_id) {
                    formData.description += "Submitter Member ID: "+ formData.submitter_id +"\n";
                }

                formData.description += $('#field-support-description').val();

                app.page.showLoader();

                app.skava.sendRequest({
                    useAPI: true,
                    url: 'v2/en-us/support/',
                    method: 'POST',
                    data: JSON.stringify(formData)

                }, function(res) {
                    console.log('success', res);
                    app.page.hideLoader();
                    $('#support-form-container').hide();
                    $('#support-form-success').show();

                    $('#btn-ok-support').on('click', app.modal.close);

                }, function(err) {
                    console.log('error', err);
                    app.page.hideLoader();
                });

            } else {
                console.log('form is invalid');
            }

            console.log(formData);
        }
    };

    return self;
}());
